import React from 'react';

function Switch({ checked, onChange, disabled = false, id, className = '', 'aria-label': ariaLabel }) {
  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`ios-switch ${checked ? 'ios-switch-on' : ''} ${disabled ? 'cursor-not-allowed opacity-50' : ''} ${className}`.trim()}
    >
      <span className="ios-switch-thumb" aria-hidden="true" />
    </button>
  );
}

export default Switch;
